import React from 'react';
import s from './PullQuote.module.scss';

interface PullQuoteProps {
  quote: string;
  author?: string | null;
}

const PullQuote: React.FC<PullQuoteProps> = ({ quote, author }) => {
  return (
    <blockquote className={s.quoteContainer} key={author}>
      <p className={s.quote}>{quote}</p>
      {author && <footer className={s.author}>{`- ${author}`}</footer>}
    </blockquote>
  );
};

export default PullQuote;
